import React from 'react'
import '../Auth.css'
import { Routes, Route, Navigate } from 'react-router-dom'
import Login from '../lms/auth/Login'
import ForgotPassword from '../lms/auth/ForgotPassword'
import ForgotPasswordOTP from '../lms/auth/ForgotPasswordOTP'

function IndexRouters() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/forgot-password/otp" element={<ForgotPasswordOTP />} />
      {/* Redirect unused auth routes to login */}
      <Route path="/register" element={<Navigate to="/login" replace />} />
      <Route path="/register-otp" element={<Navigate to="/login" replace />} />
      <Route path="/reset-password" element={<Navigate to="/login" replace />} />
      <Route path="/active-account" element={<Navigate to="/login" replace />} />
      <Route path="/active-account/otp" element={<Navigate to="/login" replace />} />
      <Route path="/send-magic-link" element={<Navigate to="/login" replace />} />
      <Route path="/check-your-email" element={<Navigate to="/login" replace />} />
      {/* Redirect any protected/unknown path to login when unauthenticated */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default IndexRouters
